module.exports = __webpack_public_path__ + "img/eductorenviro_driving.1a2c5dde.svg";